<template>
    <div class="app-container">
    <el-row class="headTop">
      <el-col :span="19">
        <span v-if="showShop">
        分店：<el-select v-model="params.shopNum"
          class="w150 mr20"
          clearable  placeholder="请选择分店">
          <el-option
          v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
        </span>
        团课名：<el-input
          class="w150"
          placeholder="请输入团课名"
          v-model="params.name"
          clearable>
        </el-input>
        <el-button class="ml20" style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
      </el-col>
      <el-col :span="2">
        <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
      </el-col>
      <el-col :span="2" style="margin-left:10px;">
      <el-button type="warning" @click="setClassRule()">惩罚规则设置</el-button>
      </el-col>
    </el-row>
    <el-dialog title="团课信息"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="分店" prop="shopNum">
                <el-select v-model="formparams.shopNum" placeholder="请选择" @change="getCardList">
                  <el-option
                  v-for="item in this.shopList"
                  :key="item.shopNum"
                  :label="item.name"
                  :value="item.shopNum"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="团课类型" prop="typecode">
                <el-select v-model="formparams.typecode" placeholder="请选择">
                    <el-option
                    v-for="item in this.options"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                    ></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
          <el-col :span="8">
            <el-form-item label="是否绑卡" label-width="140px">
              <el-switch
                v-model="formparams.ifBindCard"
                active-value= '1'
                inactive-value= '0'
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="会员卡" label-width="140px" prop="cardShortNameArray" v-if="formparams.ifBindCard=='1'">
              <el-select multiple v-model="formparams.cardShortNameArray" placeholder="请选择会员卡">
                <el-option
                v-for="item in this.cardList"
                :key="item.id"
                :label="item.name"
                :value="item.shortname"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
          <el-form-item label="团课名称" prop="name">
            <el-input class="w220" v-model="formparams.name" placeholder="请输入团课名称" maxlength="20"></el-input>
          </el-form-item>
          <!-- <el-form-item label="团课项目编码" prop="code" v-if="addType==1">
            <el-input v-model="formparams.code" placeholder="请输入团课项目编码" maxlength="20"></el-input>
          </el-form-item> -->
          
          <!-- timetype -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="预约时间类型" prop="timetype">
                <el-select v-model="formparams.timetype" placeholder="请选择">
                  <el-option
                  v-for="item in this.times"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提前预约时间" prop="appointmenttime">
                <el-input class="w220" v-model.number="formparams.appointmenttime" placeholder="请输入可提前预约时间"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="12">
              <el-form-item label="取消时间类型" prop="caneltimetype">
                <el-select v-model="formparams.caneltimetype" placeholder="请选择">
                  <el-option
                  v-for="item in this.times"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="取消预约时间" prop="caneltime">
                <el-input class="w220" v-model.number="formparams.caneltime" placeholder="请输入可取消预约时间"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="团课类型说明" prop="remark">
            <editor-bar v-model="formparams.remark" :isClear="isClear"></editor-bar>
            <!-- <el-input type="textarea" rows="4"  v-model="formparams.remark" placeholder="请输入团课类型说明"></el-input> -->
          </el-form-item>
          
          <el-form-item label="团课图片" ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="排课"  :visible.sync="dialogVisible2" width="1000px">
        <el-form :model="formparamsetClass" :rules="rules2" ref="formparamsetClass" label-width="100px">
          <el-form-item label="上课日期" prop="date">
            <!-- <el-date-picker
              v-model="formparamsetClass.recorddate"
              type="date"
              placeholder="上课日期"
              value-format="yyyy-MM-dd"
              :editable = false
              :picker-options="pickerBeginDateBefore">
            </el-date-picker> -->
          
            <el-date-picker
              v-model="date"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上课教室" prop="classroom">
            <el-select v-model="formparamsetClass.classroom" placeholder="请选择">
              <el-option v-for="item in this.roomList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择教练" prop="teacherName">
            <el-select v-model="formparamsetClass.teacherName" placeholder="请选择">
              <el-option v-for="item in this.optionsJL"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课时间" required>
            <el-time-select
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59',
                minTime: startTime
              }">
            </el-time-select>
          </el-form-item>
          <el-form-item label="最大人数" prop="maxRenshu">
            <el-input-number v-model.number="formparamsetClass.maxRenshu" :min="1"></el-input-number>
            <!-- <el-input class="w220" v-model.number="formparamsetClass.maxRenshu" placeholder="请输入上课人数"></el-input> -->
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:70px"  @click="resetForm('formparamsetClass')">取 消</el-button>
            <el-button style="width:70px"  type="primary" @click="submitSetClass('formparamsetClass')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column prop="code" label="团课编码"></el-table-column> -->
        <el-table-column prop="name" label="团课名称"></el-table-column>
        <el-table-column label="团课类型名称">
          <template slot-scope="scope">
            <div> {{scope.row.typecode|calssType}} </div>
          </template>
        </el-table-column>
        
        <el-table-column label="团课项目图片" width="150">
          <template slot-scope="scope">
            <img class="imgList" style="width:70px;height:70px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.courseimgurl" alt="">
          </template>
        </el-table-column>
        <!-- <el-table-column prop="remark" label="团课项目说明"></el-table-column> -->
        <el-table-column label="分店编号">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column label="可提前预约时间">
          <template slot-scope="scope">
            <div v-if="scope.row.tbAppointConfig"> 
              {{scope.row.tbAppointConfig.appointmenttime}}
              <span v-if="scope.row.tbAppointConfig.timetype==0">天</span>
              <span v-if="scope.row.tbAppointConfig.timetype==1">小时</span>
              <span v-if="scope.row.tbAppointConfig.timetype==2">分钟</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="可提前取消时间">
          <template slot-scope="scope">
            <div v-if="scope.row.tbAppointConfig"> 
              {{scope.row.tbAppointConfig.canceltime}}
              <span v-if="scope.row.tbAppointConfig.cancleTimeType==0">天</span>
              <span v-if="scope.row.tbAppointConfig.cancleTimeType==1">小时</span>
              <span v-if="scope.row.tbAppointConfig.cancleTimeType==2">分钟</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column  label="团课项目说明">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="300px">
              <p style="width:300px;" v-html="scope.row.remark"></p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">鼠标放上查看详情</el-tag>
              </div>
            </el-popover>
            </template>
        </el-table-column>
        <el-table-column width="300" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="success" @click="setClassTime(scope.row)">排课</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
let that;
import {getTbCourse, getVieWEJt,insertTuancaorec, getClassInfo, getTbCourseType, insertTbCourse, getShops,tuankeGetInfCs } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
import EditorBar from '../../components/wangEnduit'

export default {
  data() {
    var validDate = (rule,value,callback) => {
        if(!this.date[0] || !this.date[1]){
            callback(new Error("请选择日期"))
        }else{
            callback()
        }
    }
    return {
      loading: true,
      dialogVisible: false,
      dialogVisible2: false,
      hideUpload: false,
      showShop:false,
      isClear:false,
      times:[
        {label:'天',value:0},
        {label:'小时',value:1},
        {label:'分钟',value:2},
      ],
      times1:[
        {label:'月',value:1},
        {label:'天',value:2},
      ],
      date:[],//开始时间结束时间
      pickerBeginDateBefore:{
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      startTime:'',
      endTime:'',
      cardList: [],
      rules:{
        name:[
          { required: true, message: '请输入团课类型名称', trigger: 'blur' }
        ],
        code:[
          { required: true, message: '请输入团课项目编码', trigger: 'blur' },
          { pattern:/^\d/, message: '请输入正确的团课项目编码', trigger: 'blur' }
        ],
        appointmenttime:[
          { required: true, message: '时间不能为空'},
          { type: 'number', min:1, message: '时间必须为大于0的数字'}
        ],
        caneltimetype:[
          { required: true, message: '请选时间类型', trigger: 'change' }
        ],
        timetype:[
          { required: true, message: '请选时间类型', trigger: 'change' }
        ],
        caneltime:[
          { required: true, message: '时间不能为空'},
          { type: 'number',min:1, message: '时间必须为大于0的数字'}
        ],
        shopNum:[{ required: true, message: '请选择分店', trigger: 'blur' }],
        typecode:[{ required: true, message: '请选择团课类型', trigger: 'blur' }],
        remark:[{ required:true,message:'请输入团课类型说明',trigger:'blur' }],
        cardShortNameArray:[{ required: true, message: '请选择会员卡', trigger: 'blur' }],
      },
      rules2:{
        classroom:[
          { required: true, message: '请选择教室', trigger: 'change' }
        ],
        date: [
          {
            required: true,
            trigger: "change",
            validator: validDate
          }
        ],
        // recorddate:[
        //   { required: true, message: '请选择上课日期', trigger: 'change' }
        // ],
        teacherName:[
          { required: true, message: '请选择教师名', trigger: 'change' }
        ],
        maxRenshu:[
          { required: true, message: '人数不能为空'},
          { type: 'number', min:1, message: '人数必须为大于0的数字'}
        ]
      },
      timeList:[],
      addType:1,
      isCheckAll: true,
      formparams:{
          name:'',
          code:'',
          typecode:'',//团课类型编码
          shopNum:'',
          remark:'',
          timetype:'',
          appointmenttime:'',
          caneltimetype:'',
          caneltime:'',
          ifBindCard: '0', //是否绑卡
          cardShortNameArray: [],
      },
      newData:[],
      formparamsetClass:{
        code:'',
        recorddate:'',
        classroom:'',
        courseTime:'',
        courseName:'',
        courseType:'',
        teacherName:'',
        maxRenshu:'',
        shopNum:''
      },
      formData:{},
      fileList:[],
      optionsJL:[],
      tableData:[],
      //团课类型
      options:[],
      roomList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        shopNum:null,
        name:null,
        code:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    },
    calssType(value) {
      if (that.options.find(i => {
        return i.code == value
        })) {
        return that.options.find(i => {
            return i.code == value
        }).name
      }
    }
  },
  components: {
    mainHead,
    EditorBar
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.getShopsList()
    // setTimeout(() => {
    this.getTbCourseType()
    // }, 200);
   
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    setClassRule() {
      this.$router.push({path:'/classModule/classYuyue'})
    },
    showDialog(){
        this.dialogVisible =true
        this.addType = 1
        this.formparams.name=''
        this.formparams.code=''
        this.formparams.typecode=''
        this.formparams.shopNum=''
        this.formparams.remark=''
        this.formparams.appointmenttime=''
        this.formparams.timetype='',
        this.formparams.caneltimetype=''
        this.formparams.caneltime=''
        this.formparams.ifBindCard='0'
        this.formparams.cardShortNameArray= []
        this.hideUpload = false
        this.fileList=[]
    },
    getCardList() {
      this.formparams.cardShortNameArray = []
      if(this.formparams.shopNum) {
        this.tuankeGetInfCs()
      }
    },
    //查询线下卡列表
    tuankeGetInfCs(){
      tuankeGetInfCs({shopNum: this.formparams.shopNum}).then((res)=>{
        if(res.msg=='success'){
          this.cardList = res.data
        } else {
          this.$message.error(res.data)
        }
      })
    },
    //查询教室
    getClassInfo(shopNum){
      getClassInfo({shopNum:shopNum}).then((res)=>{
        console.log(res)
        if(res.msg == 'success'){
          this.roomList = res.data
          sessionStorage.setItem('roomList',JSON.stringify(res.data))
          this.showShop = false
        }else{
          this.showShop = true
        }
      })
    },
   //查询教练
    getVieWEJt(row){
      getVieWEJt({shopNum:row.shopnum}).then((res)=>{
        if(res.msg=='success'){
          this.optionsJL = res.data
          sessionStorage.setItem('optionsJL',JSON.stringify(res.data))
        }else {
          this.$message.error(res.data)
        }
      })
    },
    queryList(){
      this.params.pageNo = 1;
      this.currentPage = 1
      this.getTableList()
    },
    //查询团课列表
    getTableList(){
      getTbCourse(this.params).then((res)=>{
        if(res.msg == "success"){
          this.tableData = res.data.info
          this.total = res.data.total
        }
        this.loading = false
      })
    },
    getTbCourseType(){
      getTbCourseType().then(res=>{
        this.options = res.data
        console.log(this.options)
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
        }
      })
    },
    //编辑
    edit(row){
      console.log(row)
      this.addType = 2
      this.dialogVisible = true
      this.newData = row
      this.formparams.id = row.id
      this.formparams.name=row.name
      this.formparams.code=row.code
      this.formparams.typecode=row.typecode
      this.formparams.shopNum=row.shopnum
      this.formparams.remark=row.remark

      if(row.tbAppointConfig){
        this.formparams.appointmenttime=row.tbAppointConfig.appointmenttime
        this.formparams.timetype=row.tbAppointConfig.timetype
        this.formparams.caneltime=row.tbAppointConfig.canceltime
        this.formparams.caneltimetype=row.tbAppointConfig.cancleTimeType
      }else{
        this.formparams.appointmenttime=''
        this.formparams.timetype=''
        this.formparams.caneltime=''
        this.formparams.caneltimetype=''
      }
      if(this.fileList){
        this.hideUpload = true
      } else {
        this.hideUpload = false
      }
      this.fileList = []
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.courseimgurl})
      this.formparams.ifBindCard = row.ifBindCard
      this.formparams.cardShortNameArray = row.cardShortName.split('/')
      this.tuankeGetInfCs()
    },
    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('上传团课项目图片不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
              this.$message.error('上传图片大小不能超过500kb');
              this.fileList= []
              this.hideUpload= false
              return
          }
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数字字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
        if (valid) {
          this.formData = new FormData()
          this.$refs.upload.submit();
          if(this.addType == 1){
            this.formData.append('appointmenttime', this.formparams.appointmenttime);
            this.formData.append('name', this.formparams.name);
            // this.formData.append('code', this.formparams.code);
            this.formData.append('typecode', this.formparams.typecode);
            this.formData.append('shopNum', this.formparams.shopNum);

            this.formData.append('timetype', this.formparams.timetype);
            this.formData.append('caneltimetype', this.formparams.caneltimetype);
            this.formData.append('caneltime', this.formparams.caneltime);

            this.formData.append('remark', this.formparams.remark);

            this.formData.append('ifBindCard', this.formparams.ifBindCard);
            let cardShortName = this.formparams.cardShortNameArray.join('/')
            this.formData.append('cardShortName', cardShortName)
            
            let config = {
                headers: {
                  'Content-Type':'multipart/form-data',
                  'token':sessionStorage.getItem('token')
                }
            }
            this.$http.post('tuanke/insertTbCourse', this.formData, config).then((res)=>{
              console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'添加成功'
                })
              }
              this.getTableList()
            })
          } else {
            this.formData.append('id', this.formparams.id);
            this.formData.append('name', this.formparams.name);
            this.formData.append('appointmenttime', this.formparams.appointmenttime);
            this.formData.append('code', this.formparams.code);
            this.formData.append('typecode', this.formparams.typecode);
            this.formData.append('shopNum', this.formparams.shopNum);
            this.formData.append('remark', this.formparams.remark);
             this.formData.append('timetype', this.formparams.timetype);
            this.formData.append('caneltimetype', this.formparams.caneltimetype);
            this.formData.append('caneltime', this.formparams.caneltime);

            this.formData.append('ifBindCard', this.formparams.ifBindCard);
            let cardShortName = this.formparams.cardShortNameArray.join('/')
            this.formData.append('cardShortName', cardShortName)
            let config = {
                headers: {
                  'Content-Type':'multipart/form-data',
                  'token':sessionStorage.getItem('token')
                }
            }
             this.$http.post('tuanke/updateTbCourse', this.formData, config).then((res)=>{
              console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              } else {
                this.$message({
                  type:'error',
                  message:res.data.data
                })
              }
              this.getTableList()
            })
          }
          
        } else if(!this.isCheckAll) {
          this.$message.error('请将爽约设置填写完整');
          return false;
        }else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.dialogVisible2= false
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
     //项目排课
    //获取排课信息
    setClassTime(row){
      // console.log(row)
      this.dialogVisible2=true
      this.formparamsetClass.code = row.code
      this.formparamsetClass.courseName= row.name
      this.formparamsetClass.shopNum = row.shopnum
      let calssType = this.$options.filters['calssType']
      this.formparamsetClass.courseType = calssType(row.typecode)
      this.getVieWEJt(row)
      setTimeout(() => {
        this.getClassInfo(row.shopnum)
      }, 200);
    },
    //提交排课信息
    submitSetClass(formparamsetClass){
      this.$refs[formparamsetClass].validate(valid => {
        if (valid) {
          if(this.startTime == ''||this.endTime==''){
            this.$message.error('上课时间必选选择')
            return
          }
          this.formparamsetClass.courseTime = this.startTime+'-'+this.endTime
          console.log(new Date(this.date[1])-new Date(this.date[0]))
          let dateNum = new Date(this.date[1])-new Date(this.date[0])
          // console.log(dateNum/1000/60/60/24)
          if(dateNum/1000/60/60/24>30){
            this.$message.error('对不起，最大只能设置30天，请重新选择')
            return
          }
          this.formparamsetClass.recorddate = this.date[0]+','+this.date[1]
            insertTuancaorec(this.formparamsetClass).then((res)=>{
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'排课成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible2 = false
              // this.getTableList()
            })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      })
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// classProject.vue?712379bb